var render = function (_h,_vm) {var _c=_vm._c;return _c('route',_vm._b({staticClass:"navbar-item"},'route',_vm.props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }